module.exports = __webpack_public_path__ + "img/pluto129.c541e9a3.jpg";